import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, Card, CardContent, FormControlLabel, Grid, InputAdornment, MenuItem, Switch, TextField, Typography,
} from '@mui/material';
import { kirim, pesanGalat, ribuan, angka } from './bersama';

// Tab Aturan: toleransi, batas hadir/setengah hari, lupa absen pulang, pengajuan, jatah cuti, potongan gaji.

const Kartu = ({ judul, keterangan, children }) => (
  <Card variant="outlined" sx={{ mb: 2 }}>
    <CardContent>
      <Typography fontWeight={700}>{judul}</Typography>
      {keterangan && <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{keterangan}</Typography>}
      <Grid container spacing={2}>{children}</Grid>
    </CardContent>
  </Card>
);

const TabAturan = ({ data, cabang, onTersimpan }) => {
  const [isi, setIsi] = useState(null);
  const [proses, setProses] = useState(false);
  const [galat, setGalat] = useState('');
  useEffect(() => { if (data) setIsi(data); }, [data]);
  if (!isi) return null;

  const ubah = (k, v) => setIsi((s) => ({ ...s, [k]: v }));
  const bil = ({ k, label, akhiran, min = 0, step = 1, xs = 12, sm = 6, md = 3, bantuan }) => (
    <Grid item xs={xs} sm={sm} md={md}>
      <TextField fullWidth size="small" type="number" label={label} value={isi[k]} helperText={bantuan}
        inputProps={{ min, step }} onChange={(e) => ubah(k, e.target.value)}
        InputProps={akhiran ? { endAdornment: <InputAdornment position="end">{akhiran}</InputAdornment> } : undefined} />
    </Grid>
  );
  const rp = ({ k, label, bantuan }) => (
    <Grid item xs={12} sm={6} md={3}>
      <TextField fullWidth size="small" label={label} value={ribuan(isi[k])} helperText={bantuan}
        onChange={(e) => ubah(k, angka(e.target.value))}
        InputProps={{ startAdornment: <InputAdornment position="start">Rp</InputAdornment> }} />
    </Grid>
  );

  const simpan = async () => {
    setProses(true); setGalat('');
    try {
      const r = await kirim('PUT', '/absensi/pengaturan', { ...isi, cabang: cabang || undefined });
      onTersimpan(r.message || 'Tersimpan');
    } catch (e) {
      setGalat(pesanGalat(e));
    } finally {
      setProses(false);
    }
  };

  return (
    <Box>
      <Kartu judul="Jam & toleransi" keterangan="Contoh shift 07.00–15.00, toleransi 10 menit: masuk 07.08 tepat waktu, 07.25 terlambat 25 menit. Persentase dihitung dari jam kerja di dalam jam shift.">
        {bil({ k: 'toleransiTelat', label: 'Toleransi terlambat', akhiran: 'menit' })}
        {bil({ k: 'toleransiPulangCepat', label: 'Toleransi pulang cepat', akhiran: 'menit' })}
        {bil({ k: 'batasHadirPersen', label: 'Hadir bila kerja minimal', akhiran: '%', min: 1 })}
        {bil({ k: 'batasSetengahPersen', label: 'Setengah hari bila minimal', akhiran: '%' })}
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" select label="Kerja di bawah batas setengah hari" value={isi.bawahBatas} onChange={(e) => ubah('bawahBatas', e.target.value)}>
            <MenuItem value="alfa">Dihitung Alfa</MenuItem>
            <MenuItem value="setengah">Tetap Setengah hari</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" select label="Lupa absen pulang" value={isi.lupaPulang} onChange={(e) => ubah('lupaPulang', e.target.value)}>
            <MenuItem value="admin">Ditandai, admin yang memutuskan</MenuItem>
            <MenuItem value="setengah">Otomatis Setengah hari</MenuItem>
          </TextField>
        </Grid>
      </Kartu>

      <Kartu judul="Izin, sakit & cuti">
        <Grid item xs={12} sm={6}>
          <FormControlLabel control={<Switch checked={!!isi.karyawanBolehAjukan} onChange={(e) => ubah('karyawanBolehAjukan', e.target.checked)} />}
            label="Karyawan boleh mengajukan dari aplikasi (admin menyetujui)" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel control={<Switch checked={!!isi.sakitWajibSurat} onChange={(e) => ubah('sakitWajibSurat', e.target.checked)} />}
            label="Sakit wajib foto surat dokter" />
        </Grid>
        {bil({ k: 'jatahCuti', label: 'Jatah cuti per tahun', akhiran: 'hari' })}
      </Kartu>

      <Kartu judul="Gaji" keterangan="Tarif harian = gaji pokok bulanan ÷ hari kerja sebulan. Potongan dalam hari gaji (1 = sehari, 0,5 = setengah hari, 0 = tidak dipotong) atau rupiah per kejadian. Terlambat & pulang cepat hanya dipotong bila statusnya Hadir.">
        {bil({ k: 'hariKerjaSebulan', label: 'Hari kerja sebulan', akhiran: 'hari', min: 1 })}
        {bil({ k: 'potAlfaHari', label: 'Potongan Alfa', akhiran: 'hari', step: 0.5 })}
        {bil({ k: 'potSetengahHari', label: 'Potongan Setengah hari', akhiran: 'hari', step: 0.5 })}
        {bil({ k: 'potIzinHari', label: 'Potongan Izin', akhiran: 'hari', step: 0.5 })}
        {bil({ k: 'potSakitTanpaSuratHari', label: 'Potongan Sakit tanpa surat', akhiran: 'hari', step: 0.5 })}
        {bil({ k: 'potCutiLebihHari', label: 'Potongan cuti melebihi jatah', akhiran: 'hari', step: 0.5 })}
        {rp({ k: 'potTelat', label: 'Potongan terlambat', bantuan: 'per kejadian' })}
        {rp({ k: 'potPulangCepat', label: 'Potongan pulang cepat', bantuan: 'per kejadian' })}
        {bil({ k: 'tambahLiburNasionalHari', label: 'Tambahan masuk saat libur nasional', akhiran: 'hari', step: 0.5 })}
      </Kartu>

      {galat && <Alert severity="error" sx={{ mb: 2 }}>{galat}</Alert>}
      <Button variant="contained" onClick={simpan} disabled={proses}>{proses ? 'Menyimpan…' : 'Simpan pengaturan'}</Button>
    </Box>
  );
};

export default TabAturan;
